<style src="./ListItems.scss" lang="scss" scoped></style>
<template>
  <li
    class="itemrow">
    <ul class="itemcontainer">
      <column-item
        :info="item" />

      <column-result
        position="winner"
        @saved="saved"
        :info="item" />
      <column-result
        position="second"
        @saved="saved"
        :info="item" />
      <column-result
        position="third"
        @saved="saved"
        :info="item" />
    </ul>
  </li>
</template>

<script>
import ColumnItem from '../column-item/ColumnItem'
import ColumnResult from '../column-result/ColumnResult'
export default {
  name: 'ListItems',
  components: {
    ColumnItem,
    ColumnResult
  },
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  methods: {
    saved (v) {
      this.$emit('saved', v)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-analysis/components/list-items/ListItems.vue